module.exports = __webpack_public_path__ + "static/media/student-background-bottom.4b014024.png";